import * as braze from '@braze/web-sdk';

interface IProps {
    customerId: string;
}

export const initBraze = ({ customerId }: IProps) => {
  const prodKey = process.env.REACT_APP_BRAZE_PROD ?? '';
  const integKey = process.env.REACT_APP_BRAZE_INTEG ?? '';
  const baseUrl = process.env.REACT_APP_BRAZE_BASE_URL ?? '';
  return new Promise<void>((resolve) => {
    braze.initialize(
      process.env.REACT_APP_NODE_ENV === 'production' ? prodKey : integKey,
      {
        baseUrl,
        enableLogging: process.env.REACT_APP_NODE_ENV !== 'production',
        allowUserSuppliedJavascript: true,
      },
    );
    braze.automaticallyShowInAppMessages();
    braze.changeUser(customerId);
    braze.openSession();
    resolve();
  });
};
